import { LitElement, PropertyValues, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlantisEvent } from '../helpers';
import { AtlListGroupTagNames } from './list-group.props';

@customElement(AtlListGroupTagNames.ContactListGroup)
export class AtlContactListGroup extends LitElement {

    declare columns?: number;

    static styles = [
        ...getGlobalStyleSheets()
    ];

    static properties = {
        columns: {type: Number }
    }

    override updated(changedProperties: PropertyValues) {
        if (changedProperties.has('columns')) {
            this._updateColsCLass();
        }
    }

    private _handleSlotChange = (event: AtlantisEvent<Event, HTMLSlotElement>) => {
        const slot = event.target;
        const assignedNodes = slot.assignedNodes({ flatten: false });

        const group = document.createElement('div');
        group.classList.add('contacts-list-group');

        const groupContainer = document.createElement('div');
        groupContainer.classList.add('contacts-container', 'row');
        group.appendChild(groupContainer);

        const cols = this.columns === 2 ? 'col-lg-6' : 'col-lg-4';
                
        assignedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
                const item = node as HTMLElement;
                item.classList.add('col-sm-6', cols, 'mb-3');
                
                groupContainer.appendChild(item);
            }
        });

        slot?.parentNode?.replaceChild(group, slot);
    };

    private _updateColsCLass = () => {
        const groupContainer = this.shadowRoot?.querySelector('.contacts-container');
        if (groupContainer) {
            const items = groupContainer.children as HTMLCollection;
            const oldClass = this.columns === 2 ? 'col-lg-4' : 'col-lg-6';
            const newClass = this.columns === 2 ? 'col-lg-6' : 'col-lg-4';

            Array.from(items).forEach(item => {
                item.classList.remove(oldClass);
                item.classList.add(newClass);
            });
        }
    }
        
    render() {
        return html`            
            <slot @slotchange=${this._handleSlotChange}></slot>            
        `;
    }
}